import { createSelector } from '@reduxjs/toolkit'

import { RootState, TLocation } from 'types/store'

export const appState = (state: RootState) => state?.appState

export const getCurrentOffset = createSelector(
  [appState, (_, location) => location],
  (appState, location) => appState.pagination[location as TLocation].offSet
)
export const getCurrentPage = createSelector(
  [appState, (_, location) => location],
  (appState, location) => appState.pagination[location as TLocation].page
)

export const getCurrentUserEmail =
  createSelector(appState, (appState) => appState?.user?.email) ?? ''
export const getCurrentUserAppRole =
  createSelector(appState, (appState) => appState?.user?.appRole) ?? []
export const getCurrentOrgName =
  createSelector(appState, (appState) => appState?.user?.orgName) ?? []
